import { Flex, Image, Modal, Text } from "@mantine/core";

import loaderGif from "/loader.gif";

interface ProcessingKYCModalProps {
  opened: boolean;
  onClose: () => void;
}

const ProcessingKYCModal = ({ opened, onClose }: ProcessingKYCModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="sm"
      withCloseButton={true}
      closeOnClickOutside={true}
      closeOnEscape={true}
      radius="lg"
      padding="xl"
    >
      <Flex direction="column" align="center" gap={36} pb={24}>
        <Image width={80} height={40} src={loaderGif} alt="Loading..." />
        <Text align="center" color="dimmed">
          Processing KYC, please wait...
        </Text>
      </Flex>
    </Modal>
  );
};

export default ProcessingKYCModal;
